import { FormControl } from "../../../../FormControl/FormControl/FormControl.js";
import { isValidDay, isValidMonth, isValidBirthDateYear } from "../../../../Util/Util/validations.js";
const getFieldValues = (name, fields) => {
  const day = fields?.[`${name}Day`]?.value ?? "";
  const month = fields?.[`${name}Month`]?.value ?? "";
  const year = fields?.[`${name}Year`]?.value ?? "";
  return { day, month, year };
};
const isEqualState = (a, b) => a.value === b.value && a.isTouched === b.isTouched && a.isValid === b.isValid && a.readonly === b.readonly;
const updateFields = (name, fields = {}, nextState = {}) => {
  if (Object.keys(fields).length === 0) {
    return {};
  }
  const currentField = {
    value: "",
    ...fields[name],
    // Merge existing field if it exists
    ...nextState,
    // Override with nextState
    name
    // Ensure the name is always present
  };
  return {
    ...fields,
    [name]: currentField
  };
};
const getFieldNames = (name) => ({
  day: `${name}Day`,
  month: `${name}Month`,
  year: `${name}Year`
});
const joinValues = (name, fields) => {
  const { day, month, year } = getFieldValues(name, fields) ?? {};
  const formattedDay = day && day !== "00" ? day?.padStart(2, "0") : "";
  const formattedMonth = month && month !== "00" ? month?.padStart(2, "0") : "";
  return `${year}-${formattedMonth}-${formattedDay}`;
};
const initializeFields = ({
  name,
  value = "",
  isTouched = false,
  required = false
}) => {
  const isShortDate = value.includes("-");
  const isLongDate = value.includes("T") && isShortDate;
  let date = [];
  if (isLongDate) {
    date = value.split("T")[0]?.split("-") ?? [];
  } else if (isShortDate) {
    date = value.split("-");
  }
  const day = { name: `${name}Day`, value: date[2] ?? "" };
  const month = { name: `${name}Month`, value: date[1] ?? "" };
  const year = { name: `${name}Year`, value: date[0] ?? "" };
  return {
    [year.name]: {
      name: year.name,
      value: year.value,
      isTouched: isTouched || !!year.value,
      isValid: validateWithRequired(year.value, isValidBirthDateYear, { required })
    },
    [month.name]: {
      name: month.name,
      value: month.value,
      isTouched: isTouched || !!month.value,
      isValid: validateWithRequired(month.value, isValidMonth, { required })
    },
    [day.name]: {
      name: day.name,
      value: day.value,
      isTouched: isTouched || !!day.value,
      isValid: validateWithRequired(day.value, isValidDay, { required })
    }
  };
};
const validateFullDate = (name, fields, required, validation) => {
  if (!fields) {
    return false;
  }
  const { day, month, year } = getFieldValues(name, fields) ?? {};
  if (!required && (day === "" || month === "" || year === "")) {
    return true;
  }
  if ([day, month].some((item) => item?.length && item?.length > 2)) {
    return false;
  }
  const value = [year, month, day].filter((value2) => !!value2).join("-");
  const { isValid } = FormControl.validate([validation], [], required, value);
  return !validation || isValid;
};
const focusElementWhenValueReady = (value, ref) => value.length === 2 ? ref.current?.focus() : void 0;
const getErrorMessageBasedOnValidation = (validationResults, errorMessages = []) => {
  const indexOfFirstFailedValidation = validationResults.lastIndexOf(false);
  if (indexOfFirstFailedValidation === -1) {
    return "";
  }
  return errorMessages[indexOfFirstFailedValidation] ?? "Unknown error";
};
const validateWithRequired = (value, validator, options) => {
  if (!options?.required) {
    return !value ? true : validator(value);
  }
  return validator(value);
};
export {
  focusElementWhenValueReady,
  getErrorMessageBasedOnValidation,
  getFieldNames,
  initializeFields,
  isEqualState,
  joinValues,
  updateFields,
  validateFullDate,
  validateWithRequired
};
//# sourceMappingURL=utils.js.map
